var render, staticRenderFns
import script from "./comp_Carousel.vue?vue&type=script&lang=js&"
export * from "./comp_Carousel.vue?vue&type=script&lang=js&"
import style0 from "./comp_Carousel.vue?vue&type=style&index=0&id=1db19490&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db19490",
  null
  
)

export default component.exports